export const getRuntimeMeta = (name, fallback = '') => {
  if (typeof document === 'undefined') return fallback;
  const value = document.querySelector(`meta[name="${name}"]`)?.getAttribute('content');
  return value ?? fallback;
};

export const getRuntimeBasePath = () => {
  const value = (getRuntimeMeta('app-base-url', '') || '').trim();
  if (!value || value === '/') return '';
  return value.replace(/\/+$/, '');
};

export const getRuntimeBasename = () => {
  const value = (getRuntimeMeta('app-basename', '/') || '/').trim();
  if (!value) return '/';
  return value === '/' ? '/' : value.replace(/\/+$/, '');
};

export const buildAppUrl = (path = '') => {
  const base = getRuntimeBasePath();
  if (!path) return base || '';
  if (/^https?:\/\//i.test(path)) return path;
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${base}${normalizedPath}`;
};
